import { PettyCashWithdrawalReport } from '../../../types';
import { commonColProps, DataGridHandler } from '../../DataGridFlexSales';

export interface PettyCashWithdrawalReportDataGridContext {
  t: (key: string | string[]) => string;
  country: string;
}

const initialContext: PettyCashWithdrawalReportDataGridContext = {
  t: () => '',
  country: '',
};

export default (locale: Locale) => {
  const handler = new DataGridHandler<
    PettyCashWithdrawalReport,
    PettyCashWithdrawalReportDataGridContext
  >(initialContext, locale);

  handler.addColumn({
    accessor: 'country',
    type: 'string',
    title: ({ t }) => t('table.columns.country'),
    ...commonColProps.country,
  });

  handler.addColumn({
    accessor: 'store',
    type: 'string',
    title: ({ t, country }) => t([`table.columns.${country}.store`, 'table.columns.store']),
  });

  handler.addColumn({
    accessor: 'franchiseType',
    type: 'string',
    title: ({ t }) => t(['toolbar.labels.franchiseType']),
    width: { px: 100, pt: 100 },
  });

  handler.addColumn({
    accessor: 'month',
    type: 'date',
    title: ({ t }) => t('table.columns.month'),
    ...commonColProps.month,
  });

  handler.addColumn({
    accessor: 'tenderName',
    type: 'string',
    title: ({ t }) => t('table.columns.tender_name'),
  });

  handler.addColumn({
    accessor: 'extraccionCaja',
    type: 'number',
    title: ({ t }) =>
      t('accounting-info-report.petty-cash-withdrawal.columns.petty-cash-withdrawal'),
    total: { type: 'sum' },
  });

  return handler;
};
